

// src/components/ImageMarkers.js
import React, { useState, useRef } from 'react';
import {
  FaVideo,
  FaVolumeUp,
  FaLink,
  FaImage,
  FaPlay,
} from 'react-icons/fa';
import './ImageMarkers.css';

const Marker = ({
  left,
  top,
  type,
  text,       // <-- Use this for labels like '1', '2', 'Topic A', etc.
  src = '',
  url = '',
  audioSrc = '',
  children,
}) => {
  const [open, setOpen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const handleMarkerClick = (e) => {
    e.stopPropagation();
    if (type === 'audio') {
      if (audioRef.current) {
        if (isPlaying) {
          audioRef.current.pause();
          setIsPlaying(false);
        } else {
          audioRef.current.play();
          setIsPlaying(true);
        }
      }
    } else if (type === 'button' || type === 'video' || type === 'image') {
      setOpen(true);
    } else if (type === 'link' && url) {
      window.open(url, '_blank');
    }
  };

  // Show only text for button/numbered/topic markers, otherwise show relevant icons.
  const renderContent = () => {
    switch (type) {
      case 'video':
        return <FaVideo />;
      case 'audio':
        return <FaVolumeUp />;
      case 'link':
        return <FaLink />;
      case 'image':
        return <FaImage />;
      case 'button':
        // Show text label if given, e.g. "1", "2", "Topic A"
        return <span className="marker-text">{text}</span>;
      default:
        // For completely custom or generic steps
        return <span className="marker-text">{text || '?'}</span>;
    }
  };

  return (
    <>
      <div
        className={`roadmap-marker ${type === 'audio' && isPlaying ? 'audio-playing' : ''} is-${type}`}
        style={{ left, top }}
        onClick={handleMarkerClick}
        title={type}
      >
        {renderContent()}
      </div>

      {type === 'audio' && audioSrc && (
        <audio
          ref={audioRef}
          src={audioSrc}
          preload="auto"
          onEnded={() => setIsPlaying(false)}
        />
      )}

      {open && (type === 'button' || type === 'video' || type === 'image') && (
        <div className="marker-modal">
          <div className="marker-content">
            <button
              className="marker-modal-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >×</button>
            {type === 'image' && src && (
              <img
                src={src}
                alt="marker"
                style={{
                  maxWidth: 320,
                  width: '100%',
                  borderRadius: 10,
                  margin: '0 auto 20px',
                  display: 'block',
                }}
              />
            )}
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default Marker;
